<div [ngClass]="Loader.HideAllMenus ? 'd-none' : ''" *ngIf="isLoggedIn$ | async as isShowHeader">
  <nav [ngClass]="Loader.HideMenus ? 'd-none' : ''" class="navbar bg-white ShadowBottom fixed-top">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <div *ngIf="!IsMobile" class="hamrburg CursorPointer" (click)="OnClickHamerburg()" id="ExpandCollapse">
          <!-- <i class="fa fa-bars" aria-hidden="true" style="font-size: 17px;"></i> -->
          <img [src]="isFirstImage ? '../../../assets/images/Incred/MenuDuoIcon.svg' : '../../../assets/images/Incred/DuoMenuIcons2.svg'" alt="" srcset="" style="font-size: 17px;" [class.hamIconA]="isFirstImage" [class.hamIconB]="!isFirstImage" (click)="toggleImage()">
        </div>
        <a class="navbar-brand p-0" [ngClass] = "!IsMobile ? 'CursorPointer' : ''" > <!--*ngIf = 'G_UserType != 3'-->
          <img src="../../assets/images/InCred_capital_NewLogo.svg" alt="Incred Markets Logo" class="logo" routerLink='/dashboard'>
        </a>
        <div class="Welcome" *ngIf="router.url === '/dashboard'">
          <span>Welcome back, </span>
          <span class="UserName">{{UserName}}</span>
          <div class="date">{{ today | date:'EEEE, MMMM d, y' }}</div>
        </div>
         <!-- <a class="navbar-brand p-0" [ngClass] = "!IsMobile ? 'CursorPointer' : ''" *ngIf = 'G_UserType == 3'>
          <img src="../../assets/images/InCred_capital_NewLogo.svg"alt="Incred Markets Logo" class="logo" routerLink='/client-dashboard'>
        </a> -->
      </div>
      <!-- By Shubham -->
      <div class="RightSideMenu">
        <!-- <img src="../../../assets/images/Notification.svg" class="HeaderIcons" /> -->
        <div class="dropdown d-none" [ngClass]="{ 'open': isDropdownOpen }">
          <img src="../../../assets/images/Notification.svg" class="HeaderIcons dropdown-toggle"
            (click)="toggleDropdown()" />
          <!-- Add ngIf to conditionally display the red dot -->
          <!-- <div class="notification-dot" *ngIf="hasNotifications && onClickNotificationIcon"></div> -->
          <i class="fa fa-circle  text-danger-glow blink" *ngIf="hasNotifications && onClickNotificationIcon"></i>
          <div class="dropdown-content" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Notifications</h5>
                </div>
                <div class="modal-body">
                  <div *ngIf="NotificationData.length !== 0">
                    <p *ngFor="let notification of NotificationData">{{ notification.Mobile_Web }}</p>
                  </div>
                  <div *ngIf="NotificationData.length === 0">
                    <p>No Notification Found</p>
                  </div>
                </div>
                <div class="modal-footer">
                  <div></div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <!-- <img alt="N/A" src="../../../assets/images/Sidebar/act-now.svg" [ngClass]='IsMobile ? "d-block":"d-none"'
          class="HeaderIcons" routerLink="/act-now" routerLinkActive='active' *ngIf="UserType === '2' " width="24px"
          height="24px" /> -->

          <div [ngClass] = "!IsMobile && G_UserType == 3 && ClientMandateList.length > 0 ? 'd-block' : 'd-none'">
          <div class="col-2 d-flex justify-content-center">
           <a href="/mandate"> <img src="../../assets/images/Bell.gif" class="HeaderIcons widthbell" alt="bell"
            tooltip="You have mandates pending authorization. Please approve the mandate for successful execution of your SIP orders."
            autoPlacement="true" [max-width]="220" [displayTouchscreen]="true" [tooltip-class]="'CommonTooltip'"> </a>
          </div>
        </div>
        <div class="CartIconContainer" routerLink="/transaction-new-latest/cart" routerLinkActive='active'>
          <img src="../../../assets/images/Cart.svg" class="HeaderIcons" />
          <span class="CartBadge" *ngIf="CartCount > 0">{{ CartCount > 99 ? '99+' : CartCount }}</span>
        </div>
          <div class="AccountContainer"
          [class.is-open]="isAccountMenuOpen"
          (mouseenter)="openAccountMenu()"
          (mouseleave)="closeAccountMenu()">
          
       <button 
         class="AccountTrigger" 
         type="button"
         [attr.aria-expanded]="isAccountMenuOpen" 
         aria-haspopup="true" 
         aria-label="Account Menu">
         <div class="AccountC">
           <div class="profile-logo">{{ getInitials(UserName) }}</div>
           <img src="assets/images/Incred/downarrow.svg" alt="" class="AccountArrow" aria-hidden="true">
         </div>
       </button>
       
       <div class="AccountDropdown" role="menu">
         <ul class="AccountDropdownList">
           <li class="AccountDropdownItem" *ngIf="UserType == '3'" role="menuitem" tabindex="0" (click)="GoToProfile()" (keyup.enter)="GoToProfile()">
             <img class="svg" src="assets/images/Sidebar/setting.svg" alt="setting" aria-hidden="true">
             <span>My Profile</span>
           </li>
           <li class="AccountDropdownItem" role="menuitem" tabindex="0" (click)="LogOut()" (keyup.enter)="LogOut()">
             <img class="svg" src="assets/images/Sidebar/logout.svg" alt="logout" aria-hidden="true">
             <span>Logout</span>
           </li>
         </ul>
       </div>
     </div>
        <a *ngIf="!IsMobile && UserType != '1'" class="navbar-brand p-0 mr-0 ml-2">
          <ng-container *ngIf="SBLogoBase64 == '' && UserType == '2'">
            <!-- <img src="../../../assets/images/JM/IFD_Logo.png" alt="Logo" class="Companylogo_Web"> -->
            <img [src]="base64image" class="Companylogo_Web">
          </ng-container>
          <ng-container *ngIf="SBLogoBase64 != ''">
            <img [src]="SBLogoBase64" alt="Logo" class="Companylogo_Web">
          </ng-container>
        </a>
      </div>

    </div>
  </nav>
  <div [ngClass]="Loader.HideMenus && IsMobile ? '' : 'MarginTopAsHeader'">
    <!-- <nav [ngClass]='IsMobile ? "d-flex":"d-none"' class="navbar fixed-bottom bg-white">
        <ul class="navbar-nav m-0 w-100 text-center">
          <li class="nav-item active" (click)="onClickFooterMenu('Home')" routerLinkActive='active'>
            <img alt="N/A" *ngIf="!IsHomeActive" src="../../../assets/images/JM/Home_Inactive.svg" class="" />
            <img alt="N/A" *ngIf="IsHomeActive" src="../../../assets/images/JM/Home_Active.svg" class="" />
            <a [ngClass]="IsHomeActive ? 'ClrPurplr':''" class="nav-link">Home</a>
          </li>
          <li class="nav-item" (click)="onClickFooterMenu('Act')" routerLink="/transaction-new/lumpsum"
            routerLinkActive='active'>
            <img alt="N/A" *ngIf="!IsActNowActive" src="../../../assets/images/JM/Transaction_Inactive.svg" class="" />
            <img alt="N/A" *ngIf="IsActNowActive" src="../../../assets/images/JM/Transaction_Active.svg" class="" />
            <a [ngClass]="IsActNowActive ? 'ClrPurplr':''" class="nav-link">Transact</a>
          </li>
          <li class="nav-item" (click)="onClickFooterMenu('Add')" routerLinkActive='active'>
            <img alt="N/A" src="../../../assets/images/JM/Menu-Plus.svg" class=" AddImg" />
          </li>
          <li class="nav-item" (click)="onClickFooterMenu('Loyalty')" routerLink="/explore-funds-new"
            routerLinkActive='active'>
            <img alt="N/A" *ngIf="!IsLoyaltyActive" src="../../../assets/images/JM/Loyalty_Inactive.svg" class="" />
            <img alt="N/A" *ngIf="IsLoyaltyActive" src="../../../assets/images/JM/Loyalty_Active.svg" class="" />
            <a [ngClass]="IsLoyaltyActive ? 'ClrPurplr':''" class="nav-link">Explore Funds</a>
          </li>
          <li class="nav-item" id="IdOthersMenu" (click)="onClickFooterMenu('Menu')" routerLinkActive='active'>
            <img alt="N/A" src="../../../assets/images/JM/Menu_Inactive.svg" class="" />
            <a class="nav-link">Menu</a>
          </li>
        </ul>
      </nav> -->
    <!-- Starts Here For Incred Markets MF added BYy Shubham -->
    <nav [ngClass]='IsMobile ? "d-flex" : "d-none"' class="navbar fixed-bottom bg-white">
      <ul *ngIf="IsMobile && UserType == '3'" class="navbar-nav m-0 w-100 text-center">
        <li class="nav-item" routerLink="/client-dashboard" routerLinkActive="active">
          <img alt="Home Icon" src="../../../assets/images/JM/Home_new.svg" class="svg" />
          <a class="nav-link ActiveClrPurplr">Dashboard</a>
        </li>
  
        <li class="nav-item" routerLink="/transaction-new-latest/lumpsum" routerLinkActive="active"
          (click)="onTabChange('MF_Transaction_Page_Click')">
          <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Online_Transaction.svg" class="svg"
            id="ClientsMenu_Icon" />
          <a class="nav-link ActiveClrPurplr" id="ClientsMenu_text">Transaction</a>
        </li>
  
        <li class="nav-item" routerLink="/reports-new/dashboard" routerLinkActive="active"
          (click)="onTabChange('MF_Reports_Page_View')">
          <img alt="Reports Icon" src="../../../assets/images/JM/Reports.svg" class="svg" />
          <a class="nav-link ActiveClrPurplr">Reports</a>
        </li>
  
        <li class="nav-item" routerLink="/explore-funds-new-latest" routerLinkActive="active"
          (click)="onTabChange('MF_Explore_Page_View')">
          <img alt="Explore Funds Icon" src="../../../assets/images/Sidebar/Explore_Funds.svg"
            class="svg Explore_Funds" />
          <a class="nav-link ActiveClrPurplr" id="Explore_text">Explore Funds</a>
        </li>
  
        <li class="nav-item" routerLink="/transaction-new-latest/cart" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/icons/Cart.svg" class="svg" id="ClientsMenu_Icon"/>
          <a  class="nav-link ActiveClrPurplr pl-1" id="ClientsMenu_text">Cart</a>
        </li>
        <!-- <li class="nav-item" (click)="toggleCartPopup($event)">
          <img alt="N/A" src="../../../assets/images/icons/Cart.svg" class="svg" id="ClientsMenu_Icon" />
          <a class="nav-link ActiveClrPurplr pl-1" id="ClientsMenu_text">Cart</a>
        </li> -->
        <!-- <li class="nav-item hideen-menu-all" (click)="onClickFooterMenu('Menu')">
            <i class="fa fa-bars" aria-hidden="true"></i>
            <a class="nav-link ActiveClrPurplr" id="Menu_text">Menu</a>
          </li> -->
      </ul>
      <!-- Cart Popup Backdrop -->
      <div class="CartBackdrop" [class.CartBackdrop--visible]="isCartPopupOpen" (click)="closeCartPopup()">
      </div>
  
      <!-- Cart Popup Panel -->
      <div class="CartPopup" [class.CartPopup--open]="isCartPopupOpen">
        <div class="CartPopup__handle"></div>
  
        <div class="CartPopup__header">
          <span class="CartPopup__title">
            <!-- <img src="../../../assets/images/icons/Cart.svg" class="CartPopup__titleIcon" /> -->
            Quick Cart
          </span>
          <button class="CartPopup__close" (click)="closeCartPopup()">
            <i class="fa fa-times"></i>
          </button>
        </div>
  
        <ul class="CartPopup__menu">
          <li class="CartPopup__item" (click)="onCartMenuClick('/transaction-new-latest/cart')">
            <span class="CartPopup__itemIcon">
              <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
            </span>
            <span class="CartPopup__itemLabel">Lumpsum/SIP</span>
            <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
          </li>
  
          <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/redeem-summary')">
            <span class="CartPopup__itemIcon">
              <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
            </span>
            <span class="CartPopup__itemLabel">Redeem</span>
            <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
          </li>
  
          <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/switch-summary')">
            <span class="CartPopup__itemIcon">
              <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
            </span>
            <span class="CartPopup__itemLabel">Switch</span>
            <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
          </li>
  
          <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/stp-summary')">
            <span class="CartPopup__itemIcon">
              <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
            </span>
            <span class="CartPopup__itemLabel">STP</span>
            <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
          </li>
  
          <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/swp-summary')">
            <span class="CartPopup__itemIcon">
              <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
            </span>
            <span class="CartPopup__itemLabel">SWP</span>
            <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
          </li>
  
        </ul>
      </div>
    <ul *ngIf="IsMobile && UserType != '3'" class="navbar-nav m-0 w-100 text-center">
        <li class="nav-item"  routerLink="/dashboard" routerLinkActive="active">
          <img alt="Home Icon" src="../../../assets/images/JM/Home_new.svg" class="svg"/>
          <a  class="nav-link ActiveClrPurplr">Dashboard</a>
        </li>
       
        <li class="nav-item" routerLink="/reports-new/dashboard" routerLinkActive="active">
          <img alt="Reports Icon" src="../../../assets/images/JM/Reports.svg" class="svg"/>
          <a class="nav-link ActiveClrPurplr">Reports</a>
        </li>
   
        <li class="nav-item"  routerLink="/transaction-new-latest/lumpsum" routerLinkActive="active" >
          <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Online_Transaction.svg" class="svg" id="ClientsMenu_Icon"/>
          <a  class="nav-link ActiveClrPurplr" id="ClientsMenu_text">Transaction</a>
        </li>
          <!-- <li class="nav-item"  routerLink="/clients" routerLinkActive="active">
            <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Clients.svg" class="svg" id="ClientsMenu_Icon"/>
            <a  class="nav-link ActiveClrPurplr" id="ClientsMenu_text">Clients</a>
          </li> -->
        <li *ngIf="IsMobile" class="nav-item"  routerLink="/value-add-service" routerLinkActive="active">
          <img alt="Explore Funds Icon" src="../../../assets/images/Sidebar/Campaign_Management.svg" class="svg" />
          <a  class="nav-link ActiveClrPurplr" id="Clients_text">Co-Branding</a>
        </li>
        <!-- <li *ngIf="IsMobile" class="nav-item"  routerLink="/explore-funds-new-latest" routerLinkActive="active">
          <img alt="Explore Funds Icon" src="../../../assets/images/Sidebar/Explore_Funds.svg" class="svg Explore_Funds" />
          <a  class="nav-link ActiveClrPurplr" id="Explore_text">Explore Funds</a>
        </li> -->
        <li class="nav-item hideen-menu-all" (click)="onClickFooterMenu('Menu')">
          <i class="fa fa-bars" aria-hidden="true"></i>
          <a class="nav-link ActiveClrPurplr" id="Menu_text">Menu</a>
        </li>

      </ul> 
    </nav>
    <!-- Ends Here For Incred Markets MF added BYy Shubham -->
    <div id="overlay" (click)="onclickOverlay()"></div>

    <!-- for Subbroker -->
    <ul *ngIf="IsMobile && UserType != '3'" id="OthersMenuUl" class="BoxShadow OthersMenuUl" style="display:none">
      <div class="MenuSection">
        <li class="nav-item" (click)="hideMenu()" routerLink="/transaction-new-latest/lumpsum" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/JM/Transact_new.svg" class="svg" width="24px" />
          <a class="nav-link">MF</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/fd/fd-landing" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/FD.svg" class="svg" width="24px" />
          <a class="nav-link">FD</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/SGB/SGBInvest" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/SGB.svg" class="svg" width="24px" />
          <a class="nav-link">SGB</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="ipo/dashboardmain" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/NCD.svg" class="svg" width="24px" />
          <a class="nav-link">IPO/NCD</a>
        </li>
        <li class="nav-item d-none" (click)="hideMenu()" routerLink="/goal-based-investing/dashboard"
          routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/calculator.svg" class="svg" width="24px" />
          <a class="nav-link">Calculators</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/value-add-service" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/JM/Goal Based Investing_new.svg" class="svg" width="24px" />
          <a class="nav-link">Co-Branding</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/sb-emp/Sb-EmpCreation" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/user_add.svg" class="svg" width="24px" />
          <a class="nav-link mx-4">Employee Creation</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/sb-emp/Sb-EmpMapping" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/user_tag.svg" class="svg" width="24px" />
          <a class="nav-link mx-4">Employee Mapping</a>
        </li>
      </div>
      <div class="MenuDiv d-flex justify-content-center align-items-center">
        <!-- <span class="MenuTitle">Menu</span> -->
        <span class="CloseMenu" (click)="CloseMenu()"><img src="../../../assets/images/Close-white.svg" alt=""
            width="10px"></span>
      </div>
    </ul>

    <!-- other than sub broker -->
    <ul *ngIf="IsMobile && UserType == '3'" id="OthersMenuUl" class="BoxShadow OthersMenuUl" style="display:none">
      <div class="MenuSection">
        <li class="nav-item" (click)="hideMenu()" routerLink="/transaction-new-latest/lumpsum" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/JM/Transact_new.svg" class="svg" width="24px" />
          <a class="nav-link">MF</a>
        </li>
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/fd/fd-landing" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/FD.svg" class="svg" width="24px" />
          <a class="nav-link">FD</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/SGB/SGBInvest" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/SGB.svg" class="svg" width="24px" />
          <a class="nav-link">SGB</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/ipo/index" routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/Sidebar/NCD.svg" class="svg" width="24px" />
          <a class="nav-link">IPO/NCD</a>
        </li>
        <li class="nav-item d-none" (click)="hideMenu()" routerLink="/goal-based-investing/dashboard"
          routerLinkActive='active'>
          <img alt="N/A" src="../../../assets/images/JM/Goal Based Investing_new.svg" class="svg" width="24px" />
          <a class="nav-link">Calculators</a>
        </li> -->
      </div>
      <div class="MenuDiv d-flex justify-content-center align-items-center">
        <span class="CloseMenu" (click)="CloseMenu()"><img src="../../../assets/images/Close-white.svg" alt=""
            width="10px"></span>
      </div>
    </ul>

    <ul id="OthersMenuUl2" class="BoxShadow OthersMenuUl" style="display:none">
      <div class="MenuSection" id="HiddenMenu">
        <li class="nav-item" (click)="hideMenu()" (click)="GoToProfile()" *ngIf="UserType == '3'">
          <img alt="N/A" src="../../../assets/images/Sidebar/Profile.svg" class="svg"  id="HiddenMenu-icon"/>
          <a class="nav-link">My Profile</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/transaction-new-latest/cart" routerLinkActive='active'   *ngIf="UserType == '3'">
          <img alt="N/A" src="../../../assets/images/icons/Cart.svg" class="svg" id="HiddenMenu-icon-1"/>
          <a class="nav-link">Cart</a>
        </li>
        <!-- <li class="nav-item"  routerLink="/client-profile" routerLinkActive="active" *ngIf="UserType == '2'">
          <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Clients.svg" class="svg" id="HiddenMenu-icon-2"/>
          <a  class="nav-link">Add New Client</a>
        </li> -->
        <li class="nav-item" (click)="hideMenu()" routerLink="/clients" routerLinkActive="active" *ngIf="UserType != '3'">
          <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Clients.svg" class="svg" id="HiddenMenu-icon-2"/>
          <a  class="nav-link">Client</a>
        </li>
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/nominee-preview" routerLinkActive="active">
          <img alt="Transaction Icon" src="../../../assets/images/Sidebar/Clients.svg" class="svg" id="HiddenMenu-icon-2"/>
          <a  class="nav-link">Update Nominee</a>
        </li> -->
       
        <li *ngIf="ShowCOBMenu" class="nav-item" routerLink="/reports-new/change-of-broker" routerLinkActive="active">
          <img alt="Reports Icon" src="../../../assets/images/JM/Reports.svg" class="svg"/>
          <a class="nav-link ActiveClrPurplr">Change of Broker</a>
        </li>

        <li class="nav-item" (click)="toggleCartPopup($event)">
          <img alt="N/A" src="../../../assets/images/icons/Cart.svg" class="svg" id="ClientsMenu_Icon" />
          <a class="nav-link ActiveClrPurplr pl-1" id="ClientsMenu_text">Cart</a>
        </li>

        <li class="nav-item" (click)="hideMenu()" (click)="LogOut()">
          <img alt="N/A" src="../../../assets/images/Sidebar/Icon_Logout.svg" class="svg" id="HiddenMenu-icon-2"/>
          <a class="nav-link" style="color:#eb3732;">Logout</a>
        </li>
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/dashboard" routerLinkActive='active'
          *ngIf="UserType == '1'">
          <img src="../../../assets/images/JM/Home_new.svg" class="svg" width="24px" />
          <a class="nav-link">Dashboard MA </a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/dashboard" routerLinkActive='active'
          *ngIf="UserType != '3'">
          <img src="../../../assets/images/JM/Home_new.svg" class="svg" width="24px" />
          <a class="nav-link">Dashboard Client</a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/clients" routerLinkActive='active'
          *ngIf="UserType != '3'">
          <img src="../../../assets/images/Sidebar/Clients.svg" class="svg" width="24px" />
          <a class="nav-link">Clients</a>
        </li> -->
        <!-- <li class="nav-item d-none" (click)="hideMenu()" routerLink="/referral-report" routerLinkActive='active'
          *ngIf="UserType == '1'">
        
          <img src="../../../assets/images/Sidebar/Subbroker.svg" class="svg" width="24px" />
          <a class="nav-link">Subbroker</a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/campaign-management" routerLinkActive='active'
          *ngIf="UserType == '1'">
          <img src="../../../assets/images/Sidebar/Campaign_Management.svg" class="svg" width="24px" />
          <a class="nav-link">Campaign Management</a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/document-directory/upload-documents"
          routerLinkActive='active' *ngIf="UserType === '3' || UserType === '2' ">
          <img alt="N/A" src="../../../assets/images/Sidebar/document.svg" class="svg" width="24px" />
          <a class="nav-link">Documents</a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/act-now" routerLinkActive='active'
          *ngIf="UserType === '2' ">
          <img alt="N/A" src="../../../assets/images/Sidebar/Reconciliation.svg" class="svg" width="24px" />
          <a class="nav-link">Act Now</a>
        </li> -->
        <!-- <li class="nav-item" (click)="hideMenu()" routerLink="/franchise-onboarding" routerLinkActive='active'
          *ngIf="UserType === '2' ">
          <img alt="N/A" src="../../../assets/images/JM/Menu-Plus.svg" class="svg" width="24px" />
          <a class="nav-link mx-5">Franchise Onboarding</a>
        </li>
        <li class="nav-item" (click)="hideMenu()" routerLink="/client-family" routerLinkActive='active'
          *ngIf="UserType === '3'">
          <img alt="N/A" src="../../../assets/images/Sidebar/family.svg" class="svg" width="24px" />
          <a class="nav-link" *ngIf="UserType == '3'">My Family</a>
          <a class="nav-link" *ngIf="UserType != '3'">Client Family</a>
        </li> -->
     

      </div>
      <div class="MenuDiv Posi d-flex justify-content-center align-items-center">
        <!-- <span class="MenuTitle">Menu</span> -->
        <span class="CloseMenu" (click)="CloseMenu()"><img src="../../../assets/images/Close-white.svg" alt=""
            width="10px"></span>
      </div>
    </ul>
    <!-- Cart Popup Backdrop -->
    <div class="CartBackdrop" [class.CartBackdrop--visible]="isCartPopupOpen" (click)="closeCartPopup()">
    </div>

    <!-- Cart Popup Panel -->
    <div class="CartPopup" [class.CartPopup--open]="isCartPopupOpen">
      <div class="CartPopup__handle"></div>

      <div class="CartPopup__header">
        <span class="CartPopup__title">
          <!-- <img src="../../../assets/images/icons/Cart.svg" class="CartPopup__titleIcon" /> -->
          Quick Cart
        </span>
        <button class="CartPopup__close" (click)="closeCartPopup()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <ul class="CartPopup__menu">
        <li class="CartPopup__item" (click)="onCartMenuClick('/transaction-new-latest/cart')">
          <span class="CartPopup__itemIcon">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
          </span>
          <span class="CartPopup__itemLabel">Lumpsum/SIP</span>
          <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
        </li>

        <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/redeem-summary')">
          <span class="CartPopup__itemIcon">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
          </span>
          <span class="CartPopup__itemLabel">Redeem</span>
          <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
        </li>

        <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/switch-summary')">
          <span class="CartPopup__itemIcon">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
          </span>
          <span class="CartPopup__itemLabel">Switch</span>
          <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
        </li>

        <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/stp-summary')">
          <span class="CartPopup__itemIcon">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
          </span>
          <span class="CartPopup__itemLabel">STP</span>
          <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
        </li>

        <li class="CartPopup__item" (click)="onCartMenuClick('/transact-summary/swp-summary')">
          <span class="CartPopup__itemIcon">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" alt="" />
          </span>
          <span class="CartPopup__itemLabel">SWP</span>
          <i class="fa fa-chevron-right CartPopup__itemArrow"></i>
        </li>

      </ul>
    </div>
    <div *ngIf="!IsMobile && UserType == '3'">
      <ul [class.collapsed]="IsCollapseSideMenu" id="sidebar" class="Sidemenu">
        <img src="../../../assets/images/Incred/sidenav-icon-1.svg" class="grahic1" alt="">
        <img src="../../../assets/images/Incred/sidenav-icon-2.svg" class="grahic2" alt="">
        <!-- <li class="UserDetails">
          <a class="Custom_a" [ngClass]="IsCollapseSideMenu ? 'Li_a_Padding' : ''" (click)="GoToProfile()">
            <div *ngIf="IsCollapseSideMenu" class="CollapseUser"><img
                src="../../../assets/images/UserProfile_Placeholder.svg" class="UserImgDefault" /></div>
            <div *ngIf="!IsCollapseSideMenu" class="d-flex justify-content-start align-items-center BorderBott">
              <img src="../../../assets/images/UserProfile_Placeholder.svg" class="UserImg">
              <span class="UserName">{{UserName}}</span>
            </div>
          </a>
        </li> -->
        <li routerLink="/client-dashboard" routerLinkActive='active' class="mt-2">
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Home_new.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Dashboard</span>
          </a>
        </li>
        <li class="" routerLink="/transaction-new-latest/lumpsum" (click)="onTabChange('MF_Transaction_Page_Click')" routerLinkActive='active' >
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Online Transaction</span>
          </a>
        </li>
        <!-- <li class="d-none" routerLink="/goal-based-investing/dashboard" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Goal_Based_Investing.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Goal Based Investing</span>
          </a>
        </li> -->

        <!-- <li class="nav-item">
          <a class="nav-link nav-link_Arrow collapsed text-truncate" href="#fd" data-toggle="collapse"
            data-target="#fd">
            <img src="../../../assets/images/Sidebar/FD.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="d-none d-sm-inline Left_Menu">FD</span>
          </a>
          <div *ngIf="!IsCollapseSideMenu" class="collapse Trans" id="fd" aria-expanded="false">
            <ul class="flex-column pl-4 nav">
              <li class="nav-item"><a class="nav-link DropMenu_1" routerLink="/fd/fd-landing"
                  routerLinkActive="active"><span>Online FD</span></a></li>
              <li class="nav-item"><a class="nav-link DropMenu" routerLink="/fd/fd-orderbook"
                  routerLinkActive="active"><span>Order Book</span></a></li>
              <li class="nav-item"><a class="nav-link DropMenu" routerLink="/fd/bajajfd-orderbook"
                  routerLinkActive="active"><span>Bajaj FD Order Book</span></a></li>
              <li class="nav-item"><a class="nav-link DropMenu" routerLink="/fd/shriram-fd-orderbook"
                  routerLinkActive="active"><span>Shriram FD Order Book</span></a></li>
            </ul>
          </div>
        </li> -->

        <!-- <li class="nav-item">
          <a class="nav-link nav-link_Arrow collapsed text-truncate" href="#sgb" data-toggle="collapse"
            data-target="#sgb">
            <img src="../../../assets/images/Sidebar/SGB.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="d-none d-sm-inline Left_Menu">SGB</span>
          </a>
          <div *ngIf="!IsCollapseSideMenu" class="collapse Trans" id="sgb" aria-expanded="false">
            <ul class="flex-column pl-4 nav">
              <li class="nav-item"><a class="nav-link DropMenu_1" routerLink="/SGB/SGBInvest"
                  routerLinkActive="active"><span>Apply Now</span></a></li>
              <li class="nav-item"><a class="nav-link DropMenu" routerLink="/SGB/SGBOrderBook"
                  routerLinkActive="active"><span>Order Book</span></a></li>
            </ul>
          </div>
        </li> -->

        <!-- <li class="nav-item">
          <a class="nav-link nav-link_Arrow collapsed text-truncate" href="#ipo" data-toggle="collapse"
            data-target="#ipo">
            <img src="../../../assets/images/Sidebar/NCD.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="d-none d-sm-inline Left_Menu">IPO/NCD</span>
          </a>
          <div *ngIf="!IsCollapseSideMenu" class="collapse Trans" id="ipo" aria-expanded="false">
            <ul class="flex-column pl-4 nav">
              <li class="nav-item" *ngIf="UserType == '3'"><a class="nav-link DropMenu" routerLink="/ipo/AddClient"
                  routerLinkActive="active"><span>View Profile</span></a></li>
              <li class="nav-item" *ngIf="UserType == '3'"><a class="nav-link DropMenu" routerLink="/ipo/index"
                  routerLinkActive="active"><span>Apply/Track IPO</span></a></li>
              <li class="nav-item" *ngIf="UserType == '3'"><a class="nav-link DropMenu" routerLink="/ipo/index-ncd"
                  routerLinkActive="active"><span>Apply NCD </span></a></li>

            </ul>
          </div>
        </li>
        <li class="" routerLink="/explore-funds-new-latest" routerLinkActive='active'>
        </li> -->
        <li class="" routerLink="/explore-funds-new-latest" routerLinkActive='active' (click)="onTabChange('MF_Explore_Page_View')">
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Explore_Funds.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Explore Funds</span>
          </a>
        </li>

        <li class="" routerLink="/reports-new/dashboard" routerLinkActive='active' (click)="onTabChange('MF_Reports_Page_View')">
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Reports.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Reports</span>
          </a>
        </li>
        <!--Added By Devang For OM-729 On 20-05-2025-->
        <li class="">
          <a class="" href='#AuthorizationPendingSubMenu' data-toggle="collapse" data-target="#AuthorizationPendingSubMenu" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''" (click)="ShowSummaryPages()" >
            <img src="../../../assets/images/Sidebar/Online_Transaction.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Pending Orders</span>
          </a>
          <div class="collapse Trans" id="AuthorizationPendingSubMenu" aria-expanded="false"
                *ngIf="!IsCollapseSideMenu">
                <ul class="flex-column pl-4 nav">
                  <li class="nav-item">
                    <a class="nav-link DropMenu MainSubMenu" routerLink="/transaction-new-latest/cart"
                      routerLinkActive='active'>Lumpsum/SIP</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link DropMenu MainSubMenu" routerLink="/transact-summary/redeem-summary"
                      routerLinkActive='active'>Redeem</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link DropMenu MainSubMenu" routerLink="/transact-summary/switch-summary"
                      routerLinkActive='active'>Switch</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link DropMenu MainSubMenu" routerLink="/transact-summary/stp-summary"
                      routerLinkActive='active'>STP</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link DropMenu MainSubMenu" routerLink="/transact-summary/swp-summary"
                      routerLinkActive='active'>SWP</a>
                  </li>
                </ul>
              </div>
          <!-- <ul *ngIf="IsShowSummaryPages" class="">
            <li class="nav-item" routerLinkActive="active" routerLink="/transact-summary/redeem-summary">Redeem</li>
            <li class="nav-item" routerLinkActive="active" routerLink="/transact-summary/switch-summary">Switch</li>
            <li class="nav-item" routerLinkActive="active" routerLink="/transact-summary/stp-summary">STP</li>
            <li class="nav-item" routerLinkActive="active" routerLink="/transact-summary/swp-summary">SWP</li>

          </ul> -->
        </li>
        <!--End By Devang-->
         <!-- <li class="" routerLink="/reports-new/investment-summary-report" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Reports.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Investment summary report</span>
          </a>
        </li> -->
        <!-- <li class="" routerLink="/value-add-service" routerLinkActive='active'>
          <a class="d-flex align-items-center">
            <img src="../../../assets/images/Sidebar/Reports.svg" class="svg"/>
            <span *ngIf="!IsCollapseSideMenu" class="">Co-Branding</span>
          </a>
        </li> -->
        <!-- <li class="" routerLink="/document-directory/upload-documents" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/document.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Documents</span>
          </a>
        </li> -->
        <!-- <li class="" routerLink="/client-family" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/family.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu && UserType == '3'" class="">My Family</span>
          </a>
        </li> -->

        <li class="" routerLink="/nominee-preview" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Reports.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Update Nominee</span>
          </a>
        </li>
        <li class="" routerLink="/risk-profile-new" routerLinkActive='active'>
          <a class="" [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center':''">
            <img src="../../../assets/images/Sidebar/Reports.svg" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="">Risk Profile</span>
          </a>
        </li>

        <div class="BottonSideCard" [class.BottonSideCardCollapsed]="IsCollapseSideMenu">
          <li class="d-none" *ngIf="!isClientDashboardPage"><a class="d-flex align-items-center"><img src="../../../assets/images/Sidebar/setting.svg" /><span
                *ngIf="!IsCollapseSideMenu" class="Left_Menu">Settings</span></a></li>
          <li (click)="LogOut()"><a class="d-flex pb-2 align-items-center"><img
                src="../../../assets/images/Sidebar/logout.svg" /><span *ngIf="!IsCollapseSideMenu"
                class="Left_Menu">Logout</span></a></li>

          <div class="usercard">
            <div class="profile-logo2">{{ getInitials(UserName) }}</div>
            <div *ngIf="!IsCollapseSideMenu" class="UserInfo">
              <div class="UserName">{{ UserName }}</div>
              <div class="UserEmail">{{ UserEmail }}</div>
            </div>
          </div>
        </div>


      </ul>
    </div>


    <!-- For Subbroker and Employee : Dynamic menu binding : Added by Saddam -->
    <div *ngIf="!IsMobile && UserType != '3'" class="d-none">
      <div id="header" [ngClass]="IsShow" class="d-none">
        <ul [class.collapsed]="IsCollapseSideMenu" class="Sidemenu">
          <img src="../../../assets/images/Incred/sidenav-icon-1.svg" class="grahic1" alt="">
          <img src="../../../assets/images/Incred/sidenav-icon-2.svg" class="grahic2" alt="">
          <img src="../../../assets/images/Incred/arrow_right.svg" class="grahic2" alt="">
          <!-- <li class="UserDetails">
            <a class="Custom_a" [ngClass]="IsCollapseSideMenu ? 'Li_a_Padding' : ''" (click)="GoToProfile()">
              <div *ngIf="IsCollapseSideMenu" class="CollapseUser"><img
                  src="../../../assets/images/UserProfile_Placeholder.svg" class="UserImgDefault" /></div>
              <div *ngIf="!IsCollapseSideMenu" class="d-flex justify-content-start align-items-center BorderBott">
                <img src="../../../assets/images/UserProfile_Placeholder.svg" class="UserImg">
                <span class="UserName">{{UserName}}</span>
              </div>
            </a>
          </li> -->
          
          <li *ngFor="let item of MenuList; let i = index" class="nav-item mt-2 menu-trigger" routerLinkActive='active'>
            <div *ngIf="item.MainMenuURL != ''">
              <a *ngIf="!(item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www'))"
              [routerLink]="item.MainMenuURL"
              [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''" class="trigger-icon">
             <img src="{{GetImgSource(item.MainMenuName)}}" class="svg" />
             <span *ngIf="!IsCollapseSideMenu" class="d-flex align-items-center">{{item.MainMenuName}}</span>
           </a> 

           <a *ngIf="item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www')"
           (click)="onLinkClick(item)"  
           target="_blank"  
           [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''">
          <img src="{{GetImgSource(item.MainMenuName)}}" class="svg" />
          <span *ngIf="!IsCollapseSideMenu" class="d-flex align-items-center">{{item.MainMenuName}}</span>
        </a>
            </div> 

            <div *ngIf="item.MainMenuURL == ''">
              <a class="nav-link nav-link_Arrow collapsed text-truncate" href='#{{ReplaceChar(item.MainMenuName)}}'
                 data-target="#{{ReplaceChar(item.MainMenuName)}}">
                <img src="{{GetImgSource(item.MainMenuName)}}" />
                <span class="MainMenu" *ngIf="!IsCollapseSideMenu">{{item.MainMenuName}}</span>
              </a>
              <div class="flyout" id="{{ReplaceChar(item.MainMenuName)}}" aria-expanded="false"
                *ngIf="!IsCollapseSideMenu">
                <span class="flyout-arrow"></span>
                <div class="flyout-panel">
                  <div class="nav-item" *ngFor="let submenu of item.data">
                    <a class="nav-link MainSubMenu flyout-item" [routerLink]="submenu.SubMenuURL"
                      routerLinkActive='active'>{{submenu.SubMenuName}}</a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <div class="BottonSideCard" [class.BottonSideCardCollapsed]="IsCollapseSideMenu">
            <li class="d-none" *ngIf="!isClientDashboardPage"><a class="d-flex align-items-center"><img src="../../../assets/images/Sidebar/setting.svg" /><span
                  *ngIf="!IsCollapseSideMenu" class="Left_Menu">Settings</span></a></li>
            <li (click)="LogOut()"><a class="d-flex pb-2 align-items-center"><img
                  src="../../../assets/images/Sidebar/logout.svg" /><span *ngIf="!IsCollapseSideMenu"
                  class="Left_Menu">Logout</span></a></li>
          
            <div class="usercard">
              <div class="profile-logo2">{{ getInitials(UserName) }}</div>
              <div  *ngIf="!IsCollapseSideMenu" class="UserInfo">
                <div class="UserName">{{ UserName }}</div>
                <div class="UserEmail">{{ UserEmail }}</div>
              </div>
            </div>
          </div>

        </ul>
      </div>
    </div>
    <div *ngIf="!IsMobile && UserType != '3'" class="d-none">
      <div id="header" [ngClass]="IsShow">
        <ul [class.collapsed]="IsCollapseSideMenu" class="Sidemenu">

          <li *ngFor="let item of MenuList; let i = index" class="nav-item mt-2 menu-trigger" routerLinkActive='active'
              >
    
              <div *ngIf="item.MainMenuURL != ''">
                <a *ngIf="!(item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www'))"
                [routerLink]="item.MainMenuURL"
                [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''" class="trigger-icon">
               <img src="{{GetImgSource(item.MainMenuName)}}" class="svg" />
               <span *ngIf="!IsCollapseSideMenu" class="d-flex align-items-center">{{item.MainMenuName}}</span>
             </a> 
  
             <a *ngIf="item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www')"
             (click)="onLinkClick(item)"  
             target="_blank"  
             [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''">
            <img src="{{GetImgSource(item.MainMenuName)}}" class="svg" />
            <span *ngIf="!IsCollapseSideMenu" class="d-flex align-items-center">{{item.MainMenuName}}</span>
          </a>
              </div> 
    
            <div *ngIf="item.MainMenuURL == ''" (mouseenter)="onMenuHover(i, $event)" (mouseleave)="onMenuLeave()">
              <a class="nav-link nav-link_Arrow collapsed text-truncate d-flex align-items-center " [class.active]="isParentMenuActive(item)" >
                <img src="{{GetImgSource(item.MainMenuName)}}" class="svg" />
                <span class="MainMenu" *ngIf="!IsCollapseSideMenu">{{item.MainMenuName}}</span>
                <img src="../../../assets/images/Incred/arrow_right.svg" alt="" style="height: 10px;" class="ArrRght">
              </a>
              <!-- .flyout div REMOVED from here -->
            </div>
          </li>
          <!-- BottonSideCard etc unchanged -->
          <div class="BottonSideCard" [class.BottonSideCardCollapsed]="IsCollapseSideMenu">
            <li class="d-none" *ngIf="!isClientDashboardPage"><a class="d-flex align-items-center"><img src="../../../assets/images/Sidebar/setting.svg" /><span
                  *ngIf="!IsCollapseSideMenu" class="Left_Menu">Settings</span></a></li>
            <li (click)="LogOut()"><a class="d-flex pb-2 align-items-center"><img
                  src="../../../assets/images/Sidebar/logout.svg" /><span *ngIf="!IsCollapseSideMenu"
                  class="Left_Menu">Logout</span></a></li>
          
            <div class="usercard">
              <div class="profile-logo2">{{ getInitials(UserName) }}</div>
              <div  *ngIf="!IsCollapseSideMenu" class="UserInfo">
                <div class="UserName">{{ UserName }}</div>
                <div class="UserEmail">{{ UserEmail }}</div>
              </div>
            </div>
          </div>
        </ul>
    
        <!-- Single shared flyout, rendered as a SIBLING of .Sidemenu — escapes its overflow:auto -->
        <div class="flyout"
             *ngIf="hoveredMenuIndex !== null && MenuList[hoveredMenuIndex]?.data?.length"
             [style.top.px]="flyoutTop"
             [style.left.px]="flyoutLeft"
             (mouseenter)="onFlyoutEnter()"
             (mouseleave)="onMenuLeave()">
          <!-- <span class="flyout-arrow"></span> -->
          <div class="flyout-panel">
            <div class="nav-item" *ngFor="let submenu of MenuList[hoveredMenuIndex]?.data">
              <a class="nav-link MainSubMenu flyout-item" [routerLink]="submenu.SubMenuURL"
                 routerLinkActive='active'
                 [routerLinkActiveOptions]="{ exact: true }">{{submenu.SubMenuName}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!IsMobile && UserType != '3'">
      <div id="header" [ngClass]="IsShow">
    
        <ul [class.collapsed]="IsCollapseSideMenu" class="Sidemenu">
    
          <li
            *ngFor="let item of MenuList; let i = index"
            class="nav-item mt-2 menu-trigger"
            routerLinkActive="active">
    
            <!-- ================================= -->
            <!-- NORMAL MENU -->
            <!-- ================================= -->
    
            <div *ngIf="item.MainMenuURL != ''">
    
              <a
                *ngIf="!(item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www'))"
                [routerLink]="item.MainMenuURL"
                [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''"
                class="trigger-icon">
    
                <img
                  src="{{GetImgSource(item.MainMenuName)}}"
                  class="svg"
                  alt="" />
    
                <span *ngIf="!IsCollapseSideMenu"
                  class="d-flex align-items-center">
    
                  {{item.MainMenuName}}
    
                </span>
    
              </a>
    
    
              <a
                *ngIf="item.MainMenuURL.startsWith('http') || item.MainMenuURL.startsWith('www')"
                (click)="onLinkClick(item)"
                target="_blank"
                [ngClass]="!IsCollapseSideMenu ? 'd-flex align-items-center' : ''">
    
                <img
                  src="{{GetImgSource(item.MainMenuName)}}"
                  class="svg"
                  alt="" />
    
                <span *ngIf="!IsCollapseSideMenu"
                  class="d-flex align-items-center">
    
                  {{item.MainMenuName}}
    
                </span>
    
              </a>
    
            </div>
    
    
            <!-- ================================= -->
            <!-- PARENT MENU -->
            <!-- ================================= -->
    
            <div
              *ngIf="item.MainMenuURL == ''"
              (mouseenter)="onMenuHover(i, $event)"
              (mouseleave)="onMenuLeave()">
    
              <!-- =============================== -->
              <!-- COLLAPSED SIDEBAR -->
              <!-- HOVER ONLY -->
              <!-- =============================== -->
    
              <a
                *ngIf="IsCollapseSideMenu"
                href="javascript:void(0)"
                class="nav-link nav-link_Arrow text-truncate d-flex align-items-center">
    
                <img
                  src="{{GetImgSource(item.MainMenuName)}}"
                  class="svg"
                  alt="{{item.MainMenuName}}" />
    
              </a>
    
    
              <!-- =============================== -->
              <!-- EXPANDED SIDEBAR -->
              <!-- BOOTSTRAP COLLAPSE -->
              <!-- =============================== -->
    
              <a
                *ngIf="!IsCollapseSideMenu"
                class="nav-link nav-link_Arrow collapsed text-truncate d-flex align-items-center"
                [class.active]="isParentMenuActive(item)"
                href="#{{ReplaceChar(item.MainMenuName)}}"
                data-toggle="collapse"
                [attr.data-target]="'#' + ReplaceChar(item.MainMenuName)"
                aria-expanded="false">
    
                <img
                  src="{{GetImgSource(item.MainMenuName)}}"
                  class="svg"
                  alt="" />
    
                <span class="MainMenu">
                  {{item.MainMenuName}}
                </span>
    
                <!-- <img
                  src="../../../assets/images/Incred/arrow_right.svg"
                  alt=""
                  style="height: 10px;"
                  class="ArrRght" /> -->
    
              </a>
    
    
              <!-- =============================== -->
              <!-- BOOTSTRAP SUBMENU -->
              <!-- ONLY EXPANDED -->
              <!-- =============================== -->
    
              <div
                *ngIf="!IsCollapseSideMenu"
                class="collapse Trans"
                id="{{ReplaceChar(item.MainMenuName)}}"
                aria-expanded="false">
    
                <ul class="flex-column nav">
    
                  <li
                    class="nav-item"
                    *ngFor="let submenu of item.data">
    
                    <a
                      class="nav-link DropMenu MainSubMenu"
                      [routerLink]="submenu.SubMenuURL"
                      routerLinkActive="active">
    
                      {{submenu.SubMenuName}}
    
                    </a>
    
                  </li>
    
                </ul>
    
              </div>
    
            </div>
    
          </li>
    
    
          <!-- ================================= -->
          <!-- BOTTOM CARD -->
          <!-- ================================= -->
    
          <div
            class="BottonSideCard"
            [class.BottonSideCardCollapsed]="IsCollapseSideMenu">
    
            <li
              class="d-none"
              *ngIf="!isClientDashboardPage">
    
              <a class="d-flex align-items-center">
    
                <img
                  src="../../../assets/images/Sidebar/setting.svg"
                  alt="" />
    
                <span
                  *ngIf="!IsCollapseSideMenu"
                  class="Left_Menu">
    
                  Settings
    
                </span>
    
              </a>
    
            </li>
    
    
            <li (click)="LogOut()">
    
              <a class="d-flex pb-2 align-items-center">
    
                <img
                  src="../../../assets/images/Sidebar/logout.svg"
                  alt="" />
    
                <span
                  *ngIf="!IsCollapseSideMenu"
                  class="Left_Menu">
    
                  Logout
    
                </span>
    
              </a>
    
            </li>
    
    
            <div class="usercard">
    
              <div class="profile-logo2">
                {{ getInitials(UserName) }}
              </div>
    
              <div
                *ngIf="!IsCollapseSideMenu"
                class="UserInfo">
    
                <div class="UserName">
                  {{ UserName }}
                </div>
    
                <div class="UserEmail">
                  {{ UserEmail }}
                </div>
    
              </div>
    
            </div>
    
          </div>
    
        </ul>
    
    
        <!-- ===================================== -->
        <!-- SHARED FLYOUT -->
        <!-- COLLAPSED SIDEBAR ONLY -->
        <!-- ===================================== -->
    
        <div
          class="flyout"
          *ngIf="
            IsCollapseSideMenu &&
            hoveredMenuIndex !== null &&
            MenuList[hoveredMenuIndex]?.data?.length
          "
          [style.top.px]="flyoutTop"
          [style.left.px]="flyoutLeft"
          (mouseenter)="onFlyoutEnter()"
          (mouseleave)="onMenuLeave()">
    
          <div class="flyout-panel">
    
            <div
              class="nav-item"
              *ngFor="let submenu of MenuList[hoveredMenuIndex]?.data">
    
              <a
                class="nav-link MainSubMenu flyout-item"
                [routerLink]="submenu.SubMenuURL"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
    
                {{submenu.SubMenuName}}
    
              </a>
    
            </div>
    
          </div>
    
        </div>
    
      </div>
    </div>

    <div [ngClass]="Loader.HideMenus ? 'd-none' : ''" *ngIf="IsMobile" class="UserDetails_Mob">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-between align-items-center">
          <img src="../../../assets/images/UserProfile_Placeholder.svg" class="UserImg">
          <div style="line-height: 18px;">
            <div class="Hello">Hello</div>
            <div class="UserName_Mob">{{UserName}}</div>
          </div>
        </div>
        <div>
          <!-- <img src="../../../assets/images/JM/IFD_Logo.png" alt="Logo" height="38px;" class="logo"> -->
          <!-- <a *ngIf="IsMobile && UserType != '1'" class="navbar-brand p-0 mr-0 ml-2">
            <ng-container *ngIf="SBLogoBase64 == '' && UserType == '2'">
              <img src="../../../assets/images/JM/IFD_Logo.png" alt="Logo" height="38px;" class="logo">
            </ng-container>
            <ng-container *ngIf="SBLogoBase64 != ''">
              <img [src]="SBLogoBase64" alt="Logo" height="38px;" class="logo">
            </ng-container>
          </a> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="QRCode" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">QR Code</div>
      <div class="modal-body AlertModalBody">

        <div><img class="SuccessPage" class="SuccessPage" [src]="QRCodeImage"></div>
        <div class="">{{QRCodeURL}} </div>

      </div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" class="CursorPointer" (click)="CopyURL()">
          <img src="../../../assets/images/copy.svg" style="width: 25px;height: 25px;" />
          <span>{{CopyTest}}</span>

        </button>
        <button type="button" (click)="DownloadQRCode()" class="CursorPointer">Download QR Code</button>
        <button type="button" class="CursorPointer" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
